import React from 'react'

const KemetMeaning = () => {
  return (
    <>
      <p className="mt-auto flex justify-center items-center bg-[var(--primary-yellow)] p-5 rounded-md border-2 border-[var(--primary-red)] w-full">
        <div className="inline">
          <span className="text-[var(--primary-red)] font-bold m-1">Kemet</span>
          was the name used by the ancient egyptians to call their country.
        </div>
      </p>
    </>
  )
}

export default KemetMeaning
